define("analytics-resources/services/highcharts-library", ["exports", "@ember/debug", "@ember/service", "@glimmer/tracking", "highcharts", "highcharts/highcharts-more", "highcharts/modules/map", "highcharts/modules/wordcloud"], function (_exports, _debug, _service, _tracking, Highcharts, _highchartsMore, _map, _wordcloud) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"@ember/debug",0,"@ember/service",0,"@glimmer/tracking",0,"highcharts",0,"highcharts/highcharts-more",0,"highcharts/modules/map",0,"highcharts/modules/wordcloud"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let HighchartsLibraryService = _exports.default = (_dec = (0, _service.service)('user-config'), (_class = class HighchartsLibraryService extends _service.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "userConfig", _descriptor, this);
      _initializerDefineProperty(this, "isHighchartsSetup", _descriptor2, this);
    }
    get userTimeZone() {
      return this.userConfig.currentTimeZone.identifier;
    }

    /**
     * Proxy call to the Highcharts `chart` method which
     * generates a new Chart instance. Serves as a way to avoid
     * interacting with Highcharts directly from anywhere
     * outside of this service.
     * https://api.highcharts.com/class-reference/Highcharts.Chart
     */
    async chart(id, chartOptions, callback) {
      if (!this.isHighchartsSetup) {
        await this._setupHighcharts();
      }
      (false && !(document.getElementById(id)) && (0, _debug.assert)('You must provide a valid chart id', document.getElementById(id)));
      return Highcharts.chart(id, chartOptions, callback);
    }
    _setupHighcharts() {
      Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        time: {
          timezone: this.userTimeZone
        }
      });
      (0, _wordcloud.default)(Highcharts);
      (0, _map.default)(Highcharts);
      (0, _highchartsMore.default)(Highcharts);
      this.isHighchartsSetup = true;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "userConfig", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isHighchartsSetup", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class));
});